import { type } from '_u/helper'
import Vue from 'vue'
import { CellInput, CellSelect, CellInputNumber, CellDatePicker, CellSwitch } from "ivux"

// 超链接
export function anchorCell(options) {
    options = Object.assign({
        compile: function (row, column, index) {
            return row[column.key]
        }
    }, options)

    return function (h, data) {
        var { row, column, index } = data

        return h("span", {
            domProps: {
                innerHTML: options.compile.call(this, row, column, index)
            },
            class: {
                "grid-cell-link": true
            },
            on: {
                'click': function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    if (options.click) {
                        options.click.call(e.target, row, column, index)
                    }
                }
            }
        })
    }
}

// 简单的map映射，支持数组或者map对象
export function mapCell(map) {
    return function (h, data) {
        var { row, column, index } = data
        var key = row[column.key],
            value = key,
            keys
        if (type(key) == "string") {
            keys = key ? key.split(",") : []
        } else {
            keys = [key]
        }

        if (type(map) == "array") {
            let valueArr = []
            keys.forEach(el => {
                var option = map.find(v => v.id == el)
                valueArr.push(option ? option.text : el)
            })
            value = valueArr.join(",")
        }

        if (type(map) == "object") {
            let valueArr = []
            keys.forEach(el => {
                valueArr.push(map[el] ? map[el] : el)
            })
            value = valueArr.join(",")
        }

        return h("span", {
            // class: {
            //  "svu-single-line": true
            // }
        }, value)
    }
}

// 支持全局filter的管道操作
export function pipeCell(formatter) {
    return function (h, data) {
        var { row, column, index } = data
        var value = row[column.key]
        var text = formatter.trim().split("|")
            .reduce((acc, part) => {
                var matchs = /^(\w*)(?:\((.*)\))?$/.exec(part)
                var filter = Vue.options.filters[matchs[1].trim()]

                if (filter) {
                    // 目前参数只支持字符串
                    var params = matchs[2] ? matchs[2].split(",") : []

                    return filter.apply(null, [acc, ...params])
                }

                return acc
            }, value)

        return h("span", {
            // class: {
            //  "svu-single-line": true
            // }
        }, text)
    }
}

// 编辑组件
const cellEdits = {
    CellInput,
    CellSelect,
    CellInputNumber,
    CellDatePicker,
    CellSwitch,
}

export function editCell(name, options = {}) {
    return function (h, data) {
        var { props, attrs, on } = options

        return h(cellEdits[name], {
            props: Object.assign({}, data, props),
            attrs,
            on
        })
    }
}
